<div class="d-flex gap-2 position-relative">
  <button class="btn btn-secondary btn-sm" (click)="copyToClipboard(content)" title="Скопіювати посилання">
    <i class="bi bi-copy"></i>
  </button>

  @if(copied) {
  <div class="position-absolute top-100 mt-1 small text-light bg-primary p-1 rounded z-3">
    {{ 'copied' | transloco }}
  </div>
  }
</div>
